const TEST_IDS = {
  availableTokens: 'vault-vault-item-withdraw-from-vesting-vault-modal-available-tokens',
};

export default TEST_IDS;
